"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logAnalytics = exports.getAnalyticsDefault = void 0;
var getConfigData_1 = require("../autoModule/getConfigData");
var autoModuleViewHelpers_1 = require("../autoModule/views/autoModuleViewHelpers");
var getAnalyticsDefault = function (model) {
    var logAlwaysComps = [];
    var stateChangeComps = [];
    return (0, exports.logAnalytics)(model, stateChangeComps, logAlwaysComps);
};
exports.getAnalyticsDefault = getAnalyticsDefault;
var logAnalytics = function (model, logAlwaysComps, logOnChangeComps) {
    var _a, _b;
    var retData = {};
    var moduleconfig = (0, getConfigData_1.getConfigData)(model);
    var alwaysCompsDesired = (_a = moduleconfig.analytics) === null || _a === void 0 ? void 0 : _a.logAlwaysComps.concat(logAlwaysComps !== null && logAlwaysComps !== void 0 ? logAlwaysComps : []);
    retData = logAlwaysStaticAndDynamicData(model, moduleconfig, alwaysCompsDesired);
    var onChangeCompsDesired = (_b = moduleconfig.analytics) === null || _b === void 0 ? void 0 : _b.logOnChangeComps.concat(logOnChangeComps !== null && logOnChangeComps !== void 0 ? logOnChangeComps : []);
    var moduleState = model.getState();
    retData = __assign(__assign({}, retData), logOnChangeStaticAndDynamicData(moduleconfig, model, moduleState, onChangeCompsDesired));
    return retData;
};
exports.logAnalytics = logAnalytics;
var logAlwaysStaticAndDynamicData = function (model, moduleconfig, alwaysCompsDesired) {
    var _a, _b, _c;
    var retData = {};
    for (var _i = 0, _d = alwaysCompsDesired !== null && alwaysCompsDesired !== void 0 ? alwaysCompsDesired : []; _i < _d.length; _i++) {
        var eachDesiredComp = _d[_i];
        var correctMapping = void 0;
        var allComps = model.getAutoModuleAppModel().getAllComponents();
        var compObj = void 0;
        var resultantAnalyticsKey = void 0;
        if (eachDesiredComp !== "*") {
            compObj = (_a = allComps[eachDesiredComp]) === null || _a === void 0 ? void 0 : _a.component;
            if (!compObj ||
                !isCompCategoryAllowed(compObj) ||
                (0, autoModuleViewHelpers_1.isComponentInvisible)(compObj, model))
                continue;
            correctMapping = (_b = moduleconfig.analytics) === null || _b === void 0 ? void 0 : _b.compMapping[eachDesiredComp];
            resultantAnalyticsKey = !correctMapping
                ? compObj.category === "hardware"
                    ? formRegUndercSettNameForComp(compObj)
                    : eachDesiredComp
                : correctMapping;
            var value = model.getComponentValue(eachDesiredComp);
            if (value) {
                retData[resultantAnalyticsKey] = value;
            }
        }
        else {
            for (var eachCompName in allComps) {
                correctMapping = (_c = moduleconfig.analytics) === null || _c === void 0 ? void 0 : _c.compMapping[eachCompName];
                compObj = allComps[eachCompName].component;
                if (!isCompCategoryAllowed(compObj) ||
                    (0, autoModuleViewHelpers_1.isComponentInvisible)(compObj, model))
                    continue;
                resultantAnalyticsKey = !correctMapping
                    ? compObj.category === "hardware"
                        ? formRegUndercSettNameForComp(compObj)
                        : eachCompName
                    : correctMapping;
                retData[resultantAnalyticsKey] = model.getComponentValue(eachCompName);
            }
            break;
        }
    }
    return retData;
};
var formRegUndercSettNameForComp = function (compObj) {
    var regUndcSettingName = "";
    var compCategory = compObj.category;
    var compSetting = compCategory === "hardware" ? compObj.setting : "";
    var regName = getRegNameFromCompSettName(compObj.name, compSetting);
    if (regName === "") {
        regUndcSettingName = compSetting;
    }
    else if (compSetting === "") {
        regUndcSettingName = regName;
    }
    else {
        regUndcSettingName = regName + "_" + compSetting;
    }
    return regUndcSettingName;
};
var getRegNameFromCompSettName = function (compName, settingName) {
    var regNameCaps = "";
    var compNameCaps = compName.toUpperCase();
    var settingNameCaps = settingName.toUpperCase();
    regNameCaps = compNameCaps.replace(settingNameCaps, "");
    return regNameCaps;
};
var logOnChangeStaticAndDynamicData = function (moduleconfig, model, moduleState, onChangeCompsDesired) {
    var _a, _b;
    if (!onChangeCompsDesired || onChangeCompsDesired.length === 0)
        return {};
    var retData = logOnChangeDependencyComps(onChangeCompsDesired, model, moduleconfig);
    for (var eachCategoryKey in moduleState) {
        for (var eachSubCategoryKey in moduleState[eachCategoryKey]) {
            for (var eachChangedCompKey in moduleState[eachCategoryKey][eachSubCategoryKey]) {
                if ((onChangeCompsDesired === null || onChangeCompsDesired === void 0 ? void 0 : onChangeCompsDesired.indexOf(eachChangedCompKey)) !== -1 ||
                    (onChangeCompsDesired === null || onChangeCompsDesired === void 0 ? void 0 : onChangeCompsDesired.indexOf("*")) !== -1) {
                    var correctMapping = (_a = moduleconfig.analytics) === null || _a === void 0 ? void 0 : _a.compMapping[eachChangedCompKey];
                    var allComps = model.getAutoModuleAppModel().getAllComponents();
                    var compObj = (_b = allComps[eachChangedCompKey]) === null || _b === void 0 ? void 0 : _b.component;
                    if (!compObj ||
                        !isCompCategoryAllowed(compObj) ||
                        (0, autoModuleViewHelpers_1.isComponentInvisible)(compObj, model))
                        continue;
                    var resultantAnalyticsKey = !correctMapping
                        ? compObj.category === "hardware"
                            ? formRegUndercSettNameForComp(compObj)
                            : eachChangedCompKey
                        : correctMapping;
                    retData[resultantAnalyticsKey] =
                        moduleState[eachCategoryKey][eachSubCategoryKey][eachChangedCompKey];
                }
            }
        }
    }
    return retData;
};
var consolidateDependencyCompNames = function (onChangeCompsDesired, model) {
    var _a, _b;
    var consolidatedCompNames = [];
    var allComps = model.getAutoModuleAppModel().getAllComponents();
    for (var _i = 0, _c = onChangeCompsDesired !== null && onChangeCompsDesired !== void 0 ? onChangeCompsDesired : []; _i < _c.length; _i++) {
        var eachDesCompName = _c[_i];
        var compObj = (_a = allComps[eachDesCompName]) === null || _a === void 0 ? void 0 : _a.component;
        if (eachDesCompName !== "*" && (compObj === null || compObj === void 0 ? void 0 : compObj.category) === "import") {
            consolidatedCompNames.push(eachDesCompName);
        }
        else if (eachDesCompName === "*") {
            consolidatedCompNames = [];
            for (var eachcompKey in allComps) {
                compObj = (_b = allComps[eachcompKey]) === null || _b === void 0 ? void 0 : _b.component;
                if ((compObj === null || compObj === void 0 ? void 0 : compObj.category) === "import") {
                    consolidatedCompNames.push(compObj.name);
                }
            }
            break;
        }
    }
    return consolidatedCompNames;
};
var logOnChangeDependencyComps = function (onChangeCompsDesired, model, moduleconfig) {
    var _a, _b, _c;
    var result = {};
    var allComps = model.getAutoModuleAppModel().getAllComponents();
    //stage 1 - consolidating all desired comps
    var consolidatedCompNames = consolidateDependencyCompNames(onChangeCompsDesired, model);
    //stage 2 - populating the analytics data for consolidated dep comps - stage
    for (var _i = 0, consolidatedCompNames_1 = consolidatedCompNames; _i < consolidatedCompNames_1.length; _i++) {
        var eachCompName = consolidatedCompNames_1[_i];
        var correctMapping = (_b = (_a = moduleconfig.analytics) === null || _a === void 0 ? void 0 : _a.compMapping[eachCompName]) !== null && _b !== void 0 ? _b : eachCompName;
        var compObj = (_c = allComps[eachCompName]) === null || _c === void 0 ? void 0 : _c.component;
        if ((compObj === null || compObj === void 0 ? void 0 : compObj.category) !== "import")
            continue;
        var value = getDependencyCompValueForOnChange(compObj, model);
        if (value)
            result[correctMapping] = value;
    }
    return result;
};
var getDependencyCompValueForOnChange = function (compObj, model) {
    var _a;
    var result = (_a = model.getImports()[compObj.importId].handle) === null || _a === void 0 ? void 0 : _a.label;
    return result;
};
var isCompCategoryAllowed = function (compObj) {
    return (compObj !== undefined &&
        (compObj.category === "hardware" ||
            compObj.category === "software" ||
            compObj.category === "import" ||
            compObj.category === "table"));
};
//# sourceMappingURL=AnalyticsHelper.js.map